<template>
  <div>
    {{ $t('errors.not_found') }}
  </div>
</template>

<script>
export default {

}
</script>
